import clsx from 'clsx';
import { array, object, oneOfType, string } from 'prop-types';
import React, { useMemo } from 'react';
import shortid from 'shortid';
import { Input, Label, FormFeedback } from 'reactstrap';

import './styles.scss';

const Checkbox = ({
  checkboxPosition = 'right',
  className = '',
  error,
  feedback,
  label,
  innerRef,
  id,
  name,
  ...props
}) => {
  const checkboxId = useMemo(() => (id ? id : shortid.generate()), [id]);

  return (
    <div
      className={clsx(
        'custom-control',
        `custom-control-${checkboxPosition}`,
        'custom-checkbox',
        className,
      )}
    >
      <Input
        className="custom-control-input"
        id={checkboxId}
        invalid={error ? true : false}
        innerRef={innerRef}
        name={name}
        type="checkbox"
        {...props}
      />
      <Label className="custom-control-label" htmlFor={checkboxId}>
        {label}
      </Label>
      {error && (
        <FormFeedback>
          <i className="ni ni-t-warning danger pr-1" />
          {feedback}
        </FormFeedback>
      )}
    </div>
  );
};

Checkbox.propTypes = {
  children: oneOfType([array, object, string]),
  checkboxPosition: string,
  className: string,
  error: string,
  feedback: string,
  label: string,
  innerRef: object,
  id: string,
  name: string,
};

export default Checkbox;
